import React from 'react';

export class NotFoundScene extends React.Component {
  render() {
    return (
      <div className="content-center">
        <div className="alert alert-danger">
          Page not found
        </div>
      </div>
    );
  }
}
